import { CerbosApplicationActions, CerbosApplicationKind } from '@repo/cerbos-types';
import { buildAbacPrincipal, buildApplicationAttributes } from '../abac';
import { getDecision } from '../decision';
const checkActions = async (organization, user, actions, application)=>{
    var _ref;
    if (!organization || !user) {
        return actions.map(()=>false);
    }
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization),
        resource: {
            kind: CerbosApplicationKind,
            id: (_ref = application === null || application === void 0 ? void 0 : application.id) !== null && _ref !== void 0 ? _ref : organization.id,
            attributes: buildApplicationAttributes(organization, application)
        },
        actions
    });
    return actions.map((action)=>decision.isAllowed(action));
};
export const canManageConfigKey = [
    'canManageApplication',
    CerbosApplicationActions.UPDATE_APPLICATION,
    CerbosApplicationActions.UPDATE_APPLICATION_NAME,
    CerbosApplicationActions.UPDATE_APPLICATION_SETTINGS,
    CerbosApplicationActions.DELETE_APPLICATION
].join('/');
export const getCanManageAppConfig = async (organization, user, application)=>{
    const [updateApplication, updateApplicationName, updateApplicationSettings, deleteApplication] = await checkActions(organization, user, [
        CerbosApplicationActions.UPDATE_APPLICATION,
        CerbosApplicationActions.UPDATE_APPLICATION_NAME,
        CerbosApplicationActions.UPDATE_APPLICATION_SETTINGS,
        CerbosApplicationActions.DELETE_APPLICATION
    ], application);
    return {
        updateApplication: Boolean(updateApplication),
        updateApplicationName: Boolean(updateApplicationName),
        updateApplicationSettings: Boolean(updateApplicationSettings),
        deleteApplication: Boolean(deleteApplication)
    };
};
